export const getConclusionById = (state, { conclusionId }) =>
  state.conclusions.items[conclusionId] || {};

export const getConclusionPosting = state => state.conclusions.posting;
